import { CommonEvents } from '@nirvana/shared/constants';

export function handleClickOnEndpoint(e) {
  const endpointId = e.target.getAttribute('data-endpoint-id');
  this.dom.$gridView.dispatchEvent(
    new CustomEvent(CommonEvents.CLICK_ON_ENDPOINT_NAME, {
      detail: {
        endpointId,
      },
      bubbles: true,
      composed: true,
    })
  );
}

export function handleClickOnIncidentNumber(e) {
  const incidentId = e.target.getAttribute('data-incident-id');
  const incidentIsEdr = e.target.getAttribute('data-incident-is-edr');
  const incidentDetails = JSON.parse(e.target.getAttribute('data-incident-details'));

  this.dom.$gridView.dispatchEvent(
    new CustomEvent(CommonEvents.CLICK_ON_INCIDENT_NUMBER, {
      detail: {
        incidentId,
        incidentIsEdr,
        incidentDetails
      },
      bubbles: true,
      composed: true,
    })
  );
}
